export default __webpack_public_path__ + "static/media/K_Kuara.e2e40c48.mp3";